import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import FormField from "../../dynamicFormBuilder/FormField";
import { UserDefinedLayout } from "./Layout";

// User Defined tab for the IM Transaction Entry form (Delphi uIMD0019 "User Defined"): the 4x10
// user-defined Code/Reference/Date/Quantity passthroughs + the user-defined comment. Binds the same
// shared formFields as the other tabs, so these fields already round-trip via Form.js.
function UserDefinedTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const finalLayout = useMemo(() => UserDefinedLayout, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    // No coded dropdowns on this tab; onFormLoad is a required no-op for the dynamic builder.
    const handleFormLoad = useCallback(() => {}, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId="0019d019-4c67-4e89-d3fa-0019ddeeff03"
                layoutName="IMTransactionEntryUserDefinedForm"
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(UserDefinedTab);
